import { PhotoMeta } from '../../Models/PhotoFlags';
import { PhotoRecord } from '../../Models/PhotoRecord';
import { IPhotoStorage } from './IPhotoStorage';


export class PhotoStorage implements IPhotoStorage
{
    private storeName = "snaps";
    private static VERSION = 1;

    private dbPromise: Promise<IDBDatabase>;

    constructor(private dbName: string)
    {
        this.dbPromise = this.OpenDB();
    }

    private OpenDB(): Promise<IDBDatabase>
    {
        const dbName = this.dbName;
        const storeName = this.storeName; // Because js is crazy

        return new Promise((resolve, reject) =>
        {
            const req = indexedDB.open(dbName, PhotoStorage.VERSION);

            req.onupgradeneeded = () =>
            {
                const db = req.result;
                if (!db.objectStoreNames.contains(storeName))
                {
                    db.createObjectStore(storeName, { keyPath: 'Id' });
                }
            };

            req.onsuccess = () => resolve(req.result);
            req.onerror = () => reject(req.error);
        });
    }

    public async Add(record: PhotoRecord): Promise<void>
    {
        const storeName = this.storeName; // Because js is crazy

        const db = await this.dbPromise;

        return new Promise((resolve, reject) =>
        {
            const tx = db.transaction(storeName, 'readwrite');
            tx.objectStore(storeName).put(record);

            tx.oncomplete = () => resolve();
            tx.onerror = () => reject(tx.error);
        });
    }

    public async GetAll(): Promise<PhotoRecord[]>
    {
        const storeName = this.storeName; // Because js is crazy

        const db = await this.dbPromise;

        return new Promise((resolve, reject) =>
        {
            const tx = db.transaction(storeName, 'readonly');
            const req = tx.objectStore(storeName).getAll();

            req.onsuccess = () => resolve(req.result as PhotoRecord[]);
            req.onerror = () => reject(req.error);
        });
    }

    public async UpdateMeta(id: string, flags: Partial<PhotoMeta>): Promise<void>
    {
        const storeName = this.storeName; // Because js is crazy

        const db = await this.dbPromise;

        return new Promise((resolve, reject) =>
        {
            const tx = db.transaction(storeName, 'readwrite');
            const store = tx.objectStore(storeName);

            const getReq = store.get(id);

            getReq.onsuccess = () =>
            {
                const record = getReq.result as PhotoRecord | undefined;
                if (!record)
                {
                    reject(new Error('Photo not found'));
                    return;
                }

                record.Meta = { ...record.Meta, ...flags };
                store.put(record);
            };

            tx.oncomplete = () => resolve();
            tx.onerror = () => reject(tx.error);
        });
    }

    public async Delete(id: string): Promise<void>
    {
        const storeName = this.storeName; // Because js is crazy

        const db = await this.dbPromise;

        return new Promise((resolve, reject) =>
        {
            const tx = db.transaction(storeName, 'readwrite');
            tx.objectStore(storeName).delete(id);

            tx.oncomplete = () => resolve();
            tx.onerror = () => reject(tx.error);
        });
    }
}
